import {
  DEFAULT_WORLD_BALANCE,
  type WorldBalance,
} from "../../models/config/worldBalance.ts";

export const FIRE_EVENT_ID = "fire";

export interface RandomEventDefinition {
  id: string;
  probability: number;
  tileBound?: boolean;
  expiresAfterTurns?: number;
  expiresAfterTurnsRange?: { min: number; max: number };
}

export function getDefaultRandomEventDefinitions(
  balance: WorldBalance = DEFAULT_WORLD_BALANCE,
): RandomEventDefinition[] {
  return [
    {
      id: FIRE_EVENT_ID,
      probability: balance.fireEventProbability,
      tileBound: true,
      expiresAfterTurnsRange: {
        min: balance.fireDurationTurnsMin,
        max: balance.fireDurationTurnsMax,
      },
    },
  ];
}
